import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const SiteAssessment7DaysRequest = (values, userId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}RanReportKpis/SitePowerBoost`,
	data: { userId, values }
});
